import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { CollapsedResultContentWrapper, IconContainer, ResultContentWrapper, ResultTitleContainer } from '@atlassian/search-dialog';
import { messages } from '../messages';
import { CollapsedResultDetailWrapper, BoardAndListCol, BoardAndListDetail, ArchivedCol } from './trello-search-result.styled';
import { CardIcon, BoardIcon } from '../icons';
import { HoverPreviewsResultWrapper } from '../trello-hover-previews';
/**
 * Custom search result for Trello. Consisting of an amalgam of components from the search-dialog package and custom
 * created components at the Trello tab level.  Additionally, TrelloSearchResult leverages the collapsed view, the view
 * when a filter is present on the right side of the panel, even though no panel is rendered.  This attribute kicks
 * the metadata to the second level, aligning with Trello designs.
 */
export const TrelloSearchResultComponent = ({
  id,
  title,
  url,
  prefs,
  meta,
  additionalMeta,
  closed,
  isPreviewOnTrelloSearchResultsEnabled,
  isColorBlindModeEnabled,
  screen,
  onResultClick
}) => {
  const {
    formatMessage
  } = useIntl();
  const isBoard = Boolean(prefs);
  const type = useMemo(() => isBoard ? 'board' : 'card', [isBoard]);
  const metaValue = useMemo(() => isBoard && !meta.value ? formatMessage(messages.trello_private_workspace) : meta.value, [formatMessage, isBoard, meta.value]);
  const resultContentWrapperOnClick = useCallback(() => {
    if (onResultClick !== undefined) {
      onResultClick();
    }
  }, [onResultClick]);
  return /*#__PURE__*/React.createElement(HoverPreviewsResultWrapper, {
    id: id,
    title: title,
    url: url,
    prefs: prefs,
    meta: meta,
    additionalMeta: additionalMeta,
    closed: closed,
    type: type,
    isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
    isColorBlindModeEnabled: isColorBlindModeEnabled,
    screen: screen
  }, /*#__PURE__*/React.createElement(ResultContentWrapper, {
    isCollapsed: true,
    onClick: resultContentWrapperOnClick
  }, /*#__PURE__*/React.createElement(IconContainer, null, isBoard && prefs ? /*#__PURE__*/React.createElement(BoardIcon, {
    id: id,
    name: title,
    url: url,
    prefs: prefs
  }) : /*#__PURE__*/React.createElement(CardIcon, null)), /*#__PURE__*/React.createElement(CollapsedResultContentWrapper, null, /*#__PURE__*/React.createElement(ResultTitleContainer, {
    isCollapsed: true
  }, /*#__PURE__*/React.createElement("span", {
    title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined
  }, title)), /*#__PURE__*/React.createElement(CollapsedResultDetailWrapper, null, /*#__PURE__*/React.createElement(BoardAndListCol, null, /*#__PURE__*/React.createElement(BoardAndListDetail, {
    title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined
  }, metaValue), additionalMeta ? /*#__PURE__*/React.createElement(BoardAndListDetail, {
    title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined
  }, ": ", additionalMeta.value) : null), closed ? /*#__PURE__*/React.createElement(ArchivedCol, {
    title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage(messages.trello_closed_board_hover) : formatMessage(messages.trello_archived_card_hover) : undefined
  }, '• ', isBoard ? formatMessage(messages.trello_closed) : formatMessage(messages.trello_archived)) : null))));
};